<template>
  <div class="steps">
    <div class="step" :class="{active: stepNum === 1}">
      <div class="step-index van-hairline--surround">1</div>
      <div class="step-info">
        <div class="step-title">填写信息</div>
        <div class="step-desc">填写基础信息</div>
      </div>
    </div>
    <div class="step-line">
      <van-image width="40px" height="auto" fit="contain" :src="arrow"/>
    </div>
    
    <div class="step" :class="{active: stepNum === 2}">
      <div class="step-index van-hairline--surround">2</div>
      <div class="step-info">
        <div class="step-title">活动设置</div>
        <div class="step-desc">选择设置活动</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stepNum: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      arrow: require('@/assets/icons/line@1x.png')
    }
  }
}
</script>

<style lang="stylus" scoped>
.steps
  display flex
  align-items: center
  justify-content: space-around
  padding 18px 20px 0
  .step
    display: flex
    align-items: center
    &-index
      flex none
      width 25px
      height 25px
      line-height: 25px
      font-size 16px
      text-align: center
      background-color: #ffff
      color #BBB
      border-radius: 50%
    &-line
      display: flex
      align-items: center
      padding 0 10px
    &-info
      padding-left 5px
    &-title
      font-size 13px
      color #999
    &-desc
      margin-top 5px
      font-size 12px
      color #BBB
  .step.active
    .step-index
      color #fff
      background-color: #FF6B31
    .step-title
      color #333
</style>